import { FINANCE } from 'Router/routes';
import { FakePageData, SelectorValuePair } from '@4finance/cwt-test-helper';

const baseDataScenario: SelectorValuePair[] = [
  ['[data-test="finance-incomeSource-value"]', 'ENTREPRENEUR'],
  ['[data-test="finance-educationType-value"]', 'HIGH_SCHOOL'],
  ['[data-test="finance-housingType-value"]', 'OWNED'],
];

const financeScenarios: FakePageData = {
  url: FINANCE,
  items: {
    'Random Fill': [
      ['[data-test="finance-incomeSource-value"]', 'EMPLOYEE'],
      ['#monthlyIncome', '35000'],
      ['#monthlyExpenses', '10000'],
      ['[data-test="finance-educationType-value"]', 'HIGH_SCHOOL'],
      ['[data-test="finance-housingType-value"]', 'OWNED'],
      ['[data-test="increase-household-members"]', 'button'],
      ['[data-test="finance-submit"]', 'submit-button'],
    ],
    Upsale: [
      ...baseDataScenario,
      ['#monthlyIncome', '35000'],
      ['#monthlyExpenses', '10000'],
      ['[data-test="finance-submit"]', 'submit-button'],
    ],
    Downsale: [
      ...baseDataScenario,
      ['#monthlyIncome', '35000'],
      ['#monthlyExpenses', '10000'],
      ['[data-test="finance-submit"]', 'submit-button'],
    ],
    'Insufficient Income': [
      ...baseDataScenario,
      ['#monthlyIncome', '45000'],
      ['#monthlyExpenses', '10000'],
      ['[data-test="finance-submit"]', 'submit-button'],
    ],
    Rejected: [
      ...baseDataScenario,
      ['#monthlyIncome', '35000'],
      ['#monthlyExpenses', '35000'],
      ['[data-test="finance-submit"]', 'submit-button'],
    ],
  },
};

export { financeScenarios };
